module.exports = __webpack_public_path__ + "static/media/git.8b949f55.svg";